import { supportLocalStorage } from './browser-support.js';

const support = {};

support.supportLocalStorage = supportLocalStorage;

export default support;
